import { MenuItem, useMediaQuery } from '@mui/material'

import { ArrowRightPagination } from '@assets/svgs/ArrowRightPagination'
import { ArrowLeftPagination } from '@assets/svgs/ArrowLeftPagination'
import { emotionTheme } from '@styles/theme'

import type { PaginationProps } from './types'

import * as S from './styles'

export const Pagination = ({
  currentPage,
  totalPages,
  itemsPerPage,
  onPageChange,
  onItemsPerPageChange
}: PaginationProps) => {
  const isMobile = useMediaQuery(`(max-width: ${emotionTheme.screenSizes.laptop})`)

  return (
    <>
      <S.Container>
        <S.PageSize>
          {!isMobile && 'Qtd. de linhas:'}

          <S.Select value={itemsPerPage} onChange={({ target }) => onItemsPerPageChange?.(Number(target.value))}>
            {[5, 10, 20, 30].map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </S.Select>
        </S.PageSize>
        -
        <S.Paginate
          breakLabel="..."
          nextLabel={<ArrowRightPagination />}
          previousLabel={<ArrowLeftPagination />}
          pageRangeDisplayed={1}
          marginPagesDisplayed={1}
          forcePage={currentPage! - 1}
          pageCount={totalPages!}
          containerClassName="pagination"
          activeClassName="selected"
          onPageChange={({ selected }) => onPageChange?.(selected + 1)}
        />
      </S.Container>
    </>
  )
}
